<template>
  <v-container fluid class="user-centre-lc-management mt-4 px-1">
    <v-row>


      <!-- Modal ชื่อ dialogRemark -->
      <v-dialog v-model="dialogRemark" max-width="850px">
        <v-card>
          <v-card-title>
            <span class="text-h6">คีย์สำหรับการเช็คอิน</span>
          </v-card-title>
          <v-card-text>

            <v-alert
                icon="mdi-shield-lock-outline"
                prominent
                text
                type="info"
            >
              <v-row align="center">
                <v-col class="grow">
                  คีย์:<b style="color: black">{{this.remark_items.key_code}}</b><br>
                  วันเวลาหมดอายุ: {{ dataFormatter.dateFormatterTH(remark_items.key_end_at, 1) }} :
                  <b v-if="this.isExpired(remark_items.key_end_at)" style="color:red ">หมดอายุ</b>
                  <b v-else style="color:#3CD4A0 ">ยังไม่หมดอายุ</b> <br>
                  <a :href="'https://www.libarts.up.ac.th/centre/lc/room_checkin/'+this.remark_items.key_code" target="_blank">https://www.libarts.up.ac.th/centre/lc/room_checkin/{{this.remark_items.key_code}}</a>

                </v-col>
                <v-col class="shrink">
                  <v-btn @click="updateKey()">สร้างคีย์ใหม่</v-btn>
                </v-col>
              </v-row>
            </v-alert>


          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                color="secondary"
                outlined
                class="button-shadow mr-4"
                @click="dialogRemark = false"
            >
              ปิด
            </v-btn>

          </v-card-actions>
        </v-card>
      </v-dialog>


      <!-- Modal ชื่อ dialogPrint -->
      <v-dialog v-model="dialogPrint" max-width="850px">
        <v-card>
          <v-card-title>
            <span class="text-h6">พิมพ์รายงาน : จำนวนผู้ใช้บริการศูนย์ภาษา</span>
          </v-card-title>
          <v-card-text>

            <v-col cols="12" sm="12">

              <v-row align="right">

                <v-col class="d-flex" cols="12" sm="4">

                  <v-text-field
                      v-model="search_print_data.year"
                      type="number"
                      :step="1"
                      :rules="editForm.textReqRules.concat(editForm.numRules).concat([
                              v => v >= 2000 || 'ระบุปีเป็น พ.ศ. ต่ำสุดคือ 2000',
                              v => v <= 9999 || 'ระบุปีเป็น พ.ศ. สูงสุดคือ 9999',
                            ])"
                      label="ปี"
                      hint="ปี พ.ศ."
                      persistent-hint
                      required
                  ></v-text-field>

                </v-col>

                <v-col class="d-flex" cols="12" sm="6">
                  <v-select
                      v-model="search_print_data.month"
                      :rules="editForm.textReqRules"
                      :items="months"
                      item-text="text"
                      item-value="value"
                      label="ประจำเดือน"
                      required
                  ></v-select>
                </v-col>
              </v-row>
            </v-col>

            <v-data-table
                :loading="isReceiving || isDeleting"
                loading-text="Loading... Please wait"
                class="product-table"
                :headers="print_headers"
                :items="print_row"
                item-value="print_id"
                hide-default-footer
            >

              <template v-slot:item.api="{ item }">
                <v-btn style="margin-left: 10px;"
                       color="blue-grey"
                       class="ma-2 white--text"
                       @click="downloadReport(item.print_url,'xlsx')"
                >Excel
                  <v-icon
                      right
                      dark
                  >
                    mdi-file-excel
                  </v-icon>
                </v-btn>


                <v-btn style="margin-left: 10px;"
                       color="blue-grey"
                       class="ma-2 white--text"
                       @click="downloadReport(item.print_url,'pdf')"
                >PDF
                  <v-icon
                      right
                      dark
                  >
                    mdi-printer
                  </v-icon>
                </v-btn>
              </template>

            </v-data-table>


          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                color="secondary"
                outlined
                class="button-shadow mr-4"
                @click="dialogPrint = false"
            >
              ปิด
            </v-btn>

          </v-card-actions>
        </v-card>
      </v-dialog>



      <v-col cols="12">



        <v-card class="mb-1" v-if="state=='index'">


          <v-card-title class="pa-5 pb-3">
            <p>ข้อมูลการเข้าใช้บริการ (ห้องศูนย์ภาษา)</p><span
              class="grey--text font-weight-regular subtitle-2 pt-1">{{ '\xa0 (' + lc_checkin_users.length }} รายการ) </span>
            <v-spacer></v-spacer>
            <div>
              <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="ค้นหา (Search)"
                  single-line
                  hide-details
                  class="search"
              ></v-text-field>
            </div>
          </v-card-title>

          <v-card-text class="px-5">
            <v-data-table
                :loading="isReceiving || isDeleting"
                loading-text="Loading... Please wait"
                class="product-table"
                show-select
                :headers="headers"
                :items-per-page="15"
                :footer-props="{
                'items-per-page-options': [15, 25, 50,-1]
                }"
                :items="lc_checkin_users"
                :search="search"
                sort-by="id">
              <template v-slot:top v-if="lc_checkin_users.length>1">


                <template>


                  <v-btn style="margin-left: 10px;"
                         color="blue-grey"
                         class="ma-2 white--text"
                         @click="showPrint()"
                  >พิมพ์รายงาน
                    <v-icon
                        right
                        dark
                    >
                      mdi-printer
                    </v-icon>
                  </v-btn>


                  <v-btn
                      color="info"
                      dark
                      class="my-4 ml-4 button-shadow"
                      @click="showKey()"
                  > <v-icon color="white" >mdi-key</v-icon> ดูคีย์สำหรับเช็คอิน
                  </v-btn>
                </template>


              </template>


              <template v-slot:item.user_type="{ item }">
                <span>{{ displayTypeText(item.user_type) }}</span>
              </template>





            </v-data-table>
          </v-card-text>


        </v-card>

      </v-col>


    </v-row>

    <v-snackbar
        v-model="snackbar"
        :color="color"
        right
        top
        style="top: 50px">
      <div v-html="text" class=""></div>
      <template v-slot:action="{ attrs }">
        <v-btn
            dark
            text
            v-bind="attrs"
            @click="snackbar = false">
          ปิด
        </v-btn>
      </template>
    </v-snackbar>

  </v-container>
</template>

<script>
import config from "@/config";
import {mapActions, mapState} from 'vuex';
import validateRules from '@/use/validateRules.js';
import axios from "axios";
import dataFormatter from "@/use/dataFormatter";

export default {
  name: 'UserCentreCheckinLcManagement',
  data() {
    return {
      nowDate: new Date(),
      dialogRemark: false,
      dialogPrint: false,
      state: 'index',
      dialog: false,
      baseURLStorage: config.baseURLStorage,
      snackbar: null,
      search: '',
      selected: [],
      headers: [

        {text: 'รหัสสมาชิก',align: 'start', value: 'user_name'},
        {text: 'โค้ด', value: 'user_code'},
        {text: 'คำนำหน้า(TH)', value: 'prefix_title_th'},
        {text: 'ชื่อ(TH)', value: 'fname_th'},
        {text: 'สกุล(TH)', value: 'lname_th'},
        {text: 'ประเภท', value: 'user_type'},
        {text: 'คณะ/วิทยาลัย', value: 'up_department_name_th'},
        {text: 'สาขาวิชา', value: 'field_title'},
        {text: 'วันเวลา [เข้า]', value: 'created_at_th'},
        {text: 'วันเวลา [ออก]', value: 'updated_at_th'},

      ],
      data1_type_combo: [
        {v_value: 'U', v_name: 'บุคคลทั่วไป'},
        {v_value: 'E', v_name: 'บุคลากร'},
        {v_value: 'S', v_name: 'นิสิต'},
      ],
      months: [
        { value: 1, text: 'มกราคม' },
        { value: 2, text: 'กุมภาพันธ์' },
        { value: 3, text: 'มีนาคม' },
        { value: 4, text: 'เมษายน' },
        { value: 5, text: 'พฤษภาคม' },
        { value: 6, text: 'มิถุนายน' },
        { value: 7, text: 'กรกฎาคม' },
        { value: 8, text: 'สิงหาคม' },
        { value: 9, text: 'กันยายน' },
        { value: 10, text: 'ตุลาคม' },
        { value: 11, text: 'พฤศจิกายน' },
        { value: 12, text: 'ธันวาคม' }
      ],
      search_print_data: {
        year: '',// แปลงเป็น พ.ศ.
        month: '', // เดือนปัจจุบัน (0 = มกราคม)
      },
      print_headers: [
        {text: 'รหัส',align: 'start', value: 'print_id'},
        {text: 'ชื่อรายงาน', value: 'print_name'},
        {text: 'ดำเนินการ', value: 'api', sortable: false},
      ],
      print_row: [
        {print_id: '1',print_url: 'lc_master_r_001', print_name: 'จำแนกตามรายปี(พ.ศ.) และรายเดือน(ม.ค. - ธ.ค.)'},
        {print_id: '2',print_url: 'lc_master_r_002', print_name: 'กำหนดปี(พ.ศ.) กำหนดเดือน จำแนกตามหน่วยงาน'},
        {print_id: '3',print_url: 'lc_master_r_002_1', print_name: 'กำหนดปี(พ.ศ.) จำแนกตามหน่วยงาน และรายเดือน(ม.ค. - ธ.ค.) [กราฟ]'},
        {print_id: '4',print_url: 'lc_master_r_003', print_name: 'กำหนดปี(พ.ศ.) จำแนกตามชื่อผู้ใช้ และรายเดือน(ม.ค. - ธ.ค.) '},
        {print_id: '5',print_url: 'lc_master_r_003_1', print_name: 'กำหนดปี(พ.ศ.) กำหนดเดือน จำแนกตามชื่อผู้ใช้ '},
        {print_id: '6',print_url: 'lc_master_r_004', print_name: 'กำหนดปี(พ.ศ.) กำหนดเดือน แสดงชื่อ และวันเวลา [เข้า/ออก]'},
      ],

      notification: '<p class="font-weight-bold mb-0">หน้าเว็บพร้อมแล้วสำหรับการทำงาน - This page is ready',
      editedIndex: -1,
      editForm: {
        valid: true,
        userNameRules: validateRules.userNameRules,
        user_emailRules: validateRules.user_emailRules,
        barCodeRules: validateRules.barCodeRules,
        textReqRules: validateRules.textReqRules,
        numRules: validateRules.numRules,
        imageRules: validateRules.fileSingleRules(3),


      },

      remark_items: {
        key_end_at:"",
        key_code:""
      },
    }
  },
  computed: {
    // map state ใน Store ของเราเข้ามาเป็น Computed * เข้ามาเป็นตัวแปร
    // Method จะเรียก Function ทุกครั้งที่ Component re-render ใหม่ ซึ่งต่างจาก Computed จะไม่เรียก Function เมื่อ ข้อมูลไม่เปลี่ยน
    ...mapState('lc_checkin_users', ['lc_checkin_users', "isReceiving", "isDeleting", "idToDelete", "userMessage", "isUpdating", "errorMessage"]),
    formTitle() {
      return this.editedIndex === -1 ? 'เพิ่มรายการใหม่' : 'แก้ไขรายการ'
    },
    dataFormatter() {
      return dataFormatter;
    },
  },
  watch: {
    //Watched Property  คือ เฝ้าดูว่าข้อมูลในตัวแปลที่เรากําหนดมีการเปลี่ยนแปลงหรือไม่ ถ้ามีการเปลี่ยนแปลงก็จะรันคําสั่งที่เราเขียนไว้

    userMessage() {

      if (this.userMessage !== '') {
        this.notification = this.userMessage

        if (this.errorMessage == true) {
          this.addErrorNotification();
        } else {
          this.addSuccessNotification();
        }
        this.close();

      }
    }
  },
  created() {
    this.addSuccessNotification();
  },
  mounted() {

    //ดึงฟังก์ชั่น จาก store
    this.getUsersRequest();


  },
  methods: {
    // mapAction() เป็น function สําหรับ map action ใน Store ของเราเข้ามาเป็น Methods
    ...mapActions('lc_checkin_users',
        [
          "getUsersRequest",
          "deleteUserRequest",
          "updateUserRequest",
          "createUserRequest"
        ]
    ),


    showKey() {
      this.remark_items =[];
      try {
        const formData = new FormData();

        formData.append('page_code', 'lc_room_checkin');

        axios.post(config.baseURLApi + '/get_temp_key', formData, {
          headers: {},
        }).then(res => {

          this.remark_items = res.data[0]
          console.log("remark")
          console.log(res.data)
          this.dialogRemark = true


        });

      } catch (e) {
        this.showSnackbar(e);
      }
    },
    updateKey() {
      this.remark_items =[];
      try {
        const formData = new FormData();

        formData.append('page_code', 'lc_room_checkin');

        axios.post(config.baseURLApi + '/update_temp_key', formData, {
          headers: {},
        }).then(res => {

          this.remark_items = res.data
          console.log("update")
          console.log(res.data)



        });

      } catch (e) {
        this.showSnackbar(e);
      }
    },
    showPrint() {
      this.search_print_data.year = this.nowDate.getFullYear() + 543; // แปลงเป็น พ.ศ.
      this.search_print_data.month = this.nowDate.getMonth() + 1; // เดือนปัจจุบัน (0 = มกราคม)
      this.dialogPrint= true
    },
    downloadReport(print_url,extension){

      var year = this.search_print_data.year*1-543; // แปลงเป็น ค.ศ.
      var month = this.search_print_data.month
      var url = config.baseURLReport + '/'+print_url+'/' +extension+ '/'+ year+'/'+month;
      window.open(url);
    },
    isExpired(key_end_at) {
      const now = new Date();                  // เวลาปัจจุบัน
      const targetDate = new Date(key_end_at);   // แปลง string เป็น Date
      return targetDate < now;  // ถ้า targetDate อยู่ก่อน now = หมดอายุ
    },

    displayTypeText(item) {

      return !this.data1_type_combo.length == true ? '' : (this.data1_type_combo.find(combobox => combobox.v_value === item)).v_name;

    },

    close() {
      if (this.errorMessage == false || this.userMessage == '') {
        this.state = "index";
        this.editedIndex = -1
      }

    },
    save() {




    },
    addSuccessNotification() {
      this.snackbar = true;
      this.color = config.light.success;
      this.text = this.notification;

    },
    addErrorNotification() {
      this.snackbar = true;
      this.color = config.light.secondary;
      this.text = this.notification;
    },


    validate() {
      if (this.$refs.form.validate()) this.save()
    },

    reset() {
      this.$refs.form.reset()
    },

    cancelForm() {
      this.$refs.form.reset()
      // this.close()
      this.state = "index";
      this.editedIndex = -1
    },





  },
  async beforeMount() {
  },
  components: {

  },
}
</script>

<style src="./UserCentreCheckinLcManagement.scss" lang="scss"/>
